import { render, staticRenderFns } from "./AiSparkIcon.vue?vue&type=template&id=0142f2a2&scoped=true"
import script from "./AiSparkIcon.vue?vue&type=script&lang=js"
export * from "./AiSparkIcon.vue?vue&type=script&lang=js"
import style0 from "./AiSparkIcon.vue?vue&type=style&index=0&id=0142f2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0142f2a2",
  null
  
)

export default component.exports